import { LoadingOverlay, Box, Card, Flex, Title, Text } from '@mantine/core';

import { typedEntries } from '@/shared/utils/helpers/common';
import { paymentsStatsTitles } from '@/modules/payments/utils/const/common';

import type { TPaymentsStats } from '@/modules/payments/store/types';

type Props = {
  data?: TPaymentsStats;
  isLoading?: boolean;
};

export const Stats = (props: Props) => {
  const {
    data,
    isLoading,
  } = props;

  return (
    <Box style={{ position: 'relative' }}>
      <LoadingOverlay
        visible={isLoading}
        overlayProps={{ blur: 2 }}
      />

      <Card withBorder shadow="sm" radius="md" maw={420}>
        <Title size={18} mb={10}>Платежи</Title>
        {data && typedEntries(data).map(([name, value]) => (
          <Flex justify={'space-between'} mb={5} style={{ borderBottom: '1px solid #ddd' }}>
            <Text>{paymentsStatsTitles[name]}</Text>
            <Text fw={'bold'}>{value}</Text>
          </Flex>
        ))}
      </Card>
    </Box>
  );
};
